import { useState, useEffect } from "react";

const Settings = () => {
  // State to track the selected QR code
  const [selectedQR, setSelectedQR] = useState(null);

  // QR code descriptions
  const descriptions = [
    "Maximum damage-resistant pattern",
    "Optimally damage-resistant pattern",
    "Balanced cluttered-looking pattern",
    "Less cluttered-looking pattern",
  ];

  return (
    <div className="flex flex-col md:flex-row min-h-screen ">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 p-4 sm:p-8">
          <div className="bg-white shadow h-full rounded-lg p-4 sm:p-6 text-sm">
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
              <div className="text-base sm:text-lg font-semibold text-[#111827] mb-4 sm:mb-0">
                General Settings
              </div>
            </div>
            <hr />

            <div>
              <h2 className="font-semibold text-lg">QR Code Settings</h2>
              <p>Choose an error correction level to generate a QR Code</p>
            </div>

            {/* QR Code Options */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-8">
              {["Best", "High", "Medium", "Smallest"].map((label, index) => (
                <div
                  key={label}
                  className={`p-4 border rounded-lg cursor-pointer text-center transform transition-all duration-300 
                    ${
                      selectedQR === label
                        ? "bg-green-100"
                        : "bg-white border-gray-300"
                    } 
                    hover:bg-green-100 hover:border-green-300`}
                >
                  <h3
                    className={`text-base ${
                      selectedQR === label ? "text-green-700" : "text-gray-900"
                    }`}
                  >
                    {label}
                  </h3>
                  <p className="text-sm text-gray-500">{descriptions[index]}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
